import { css } from "@emotion/css";
import { ColorField as AriaColorField, Input } from "react-aria-components";
import { Text } from "../../../foundations/typography/Text";

interface ColorFieldProps {
  label: string;
}

export function ColorField(props: ColorFieldProps) {
  return (
    <AriaColorField
      {...props}
      className={styles.field}
      aria-label={props.label}
    >
      <Text style="input/label">{props.label}</Text>
      <Input className={styles.input} />
    </AriaColorField>
  );
}

const styles = {
  field: css({
    display: "flex",
    flexDirection: "column",
    color: "var(--text-color)",
  }),
  input: css({
    border: "none",
    padding: "var(--space-2)",
    borderRadius: "var(--border-radius-2, 4px)",
    background: "var(--background-input, #FFF)",
    color: "var(--text-base)",
  }),
};
